{
  "en": {
    "sublines": {
      "impressum": {
        "general": "General Information (according to § 5 TMG)",
        "disclaimer": "Disclaimer",
        "copyright": "Copyright",
        "thirdpartycontent": "Credits",
        "sponsors": "Sponsors",
        "liabilityInternal": "Limitation of liability for internal content",
        "liabilityExternal": "Limitation of liability for external links"
      }
    }
  }
}
